import { createI18n } from "vue-i18n"

const messages = {
    es: {
        // ShipsTable traducciones
        app_title: "ECOBUQ",
        home_p: `Simulador de configurador de medidas en buques para mejorar su eficiencia económica y ambiental, que
            permite el cálculo del <strong>Índice de Eco-eficiencia</strong> y el
            <strong>Índice operativo de la intensidad de carbono</strong> obtenido con las medidas. `,
        headerConf: "Configuracciones",
        toastProgressSpinner: "Espera un momento, por favor...",
        name: "Nombre",
        shipType: "Tipo de Barco",
        requiredEEXI: "EEXI requerido",
        attainedEEXI: "EEXI conseguido",
        actions: "Acciones",
        newShipBtn: "Nuevo Barco",
        tooltipEditShip: "Editar Barco",
        tooltipNewConfig: "Nueva Configuración",
        tooltipDeleteShip: "Borrar Barco",
        tooltipChart: "Mostrar Gráfica",
        tooltipEditConfig: "Editar Configuración",
        tooltipEditEco: "Editar parte económica",
        tooltipSetBase: "Establecer como configuración base",
        tooltipAlreadyBase: "Esta configuración ya es base",
        tooltipCloneConfig: "Clonar configuración",
        tooltipDeleteConfig: "Borrar configuración",

        dialogChart: "Datos económicos",
        dialogChartSelec: "Seleccione los datos",
        deleteShipDisplay: "¿Estás seguro de que quieres eliminar el barco llamado ",
        deleteConfigDisplay: "¿Estás seguro de que quieres eliminar la configuración llamada ",

        //EditShip traducciones
        shipName: "Nombre del barco",
        imoNumber: "Número IMO",
        iceClass: "Navegación en hielo",
        grossTonnage: "Arqueo Bruto",
        capacityDeadWeight: "Peso muerto del buque",
        dateKeelLaid: "Fecha de puesta de quilla ",
        dateSigning: "Fecha de contrato",
        dataDelivery: "Fecha de entrega",
        displacementVolume: "Volumen de desplazamiento",
        lengthOverall: "Longitud total",
        lengthbtwPerpendicular: "Eslora entre perpendiculares",
        summerLoad: "Calado en la línea de carga de verano",
        breadth: "Manga",
        shipSpeed: "Velocidad de referencia",
        vTanks: "Capacidad cúbica total de los tanques de carga",
        powerLimitElement:
            "Curvas de velocidad-potencia obtenidas a partir de las pruebas del modelo en la fase final o del informe de las pruebas en el mar",
        vsService: "Velocidad de servicio en las pruebas",
        dwtsService: "Peso muerto al calado de diseño",
        psService: "Potencia del motor principal",
        structuralEnhancement: "Mejoras estructurales voluntarias específicas",
        lwtReferenceDesign: "Desplazamiento en rosca del proyecto de referencia",
        lwtEnhancedDesign: "Desplazamiento en rosca del proyecto mejorado",
        has_csr: "Buques sujetos a las reglas estructurales comunes (CSR)",
        deadweightCSR: "Peso muerto CSR",
        lightweightCSR: "Desplazamiento en rosca CSR",
        has_sideLoaders: "¿Dispone de cargadores laterales?",
        capacityNoSideloaders: "Capacidad sin cargadores laterales",
        capacitySideloaders: "Capacidad con cargadores laterales",
        highSpeedCruise: "Crucero de alta velocidad",
        has_roro_ramps: "¿Dispone de rampas de transbordo?",
        capacityNoRORORamp: "Capacidad sin rampas de transbordo",
        capacityRORORamp: "Capacidad con rampas de transbordo",
        isChemicalTanker: "¿El buque es quimiquero?",
        capacityCorrection: "Corrección de la capacidad para buques con clasificación para navegación en hielo?",
        cb: "Coeficiente de bloque",
        addCrane: "Añadir grúa",
        removeCrane: "Eliminar grúa",
        requiredFields: "Campos Obligatorios",
        save: "Guardar",
        cancel: "Cancelar",
        showInfo: "Mostrar Informe",
        calcRequiredEEXI: "Calculo EEXI requerido",
        create: "Crear",
        description: "descripción",
        close: "Cerrar",

        //FormEditConfigurations

        configName: "Nombre Configuraciión",
        configDescription: "Descripción de la Configuración",
        modifiedGT: "GT Modificado",
        modifiedDWT: "DWT Modificado",
        forceVRefCalc: "Vref calculo forzado",
        factors: "Factores",
        shipDesignEle: "Elementos de diseño específicos del buque",
        capacityFactor: "Factor de capacidad para la limitación técnica/reglamentaria de la capacidad",
        fi: "fi no applicado",
        cubicCapacity: "Factor de corrección de la capacidad cúbica",
        fc: "fc no applicado",
        factorGeneral:
            "Factor para los buques de carga general equipados con grúas y otros equipos relacionados con la carga",
        factorSpeed: "Factor de reducción de velocidad en el mar",
        fw: "fw no applicado",
        factorIce: "Factor para buques de clase hielo con IA o IA Super",
        fm: "fm no applicado",
        capacity: "Capacidad",
        calculate: "Calcular",
        fj: "fj no applicado",

        //ShipsPartTable

        logger: "Registro EEXI Calculado",
        addAnother: "Añadir otro",
        pendingComponent: "Componente Pendiente",
        confirm: "Confirmar",
        headerAuxiliaryEngineEmissions: "¿Estás seguro de que quieres borrar las emisiones del motor auxiliar llamadas",
        headerAuxiliaryEngineEnergySavings:
            "Está seguro de que desea eliminar el ahorro de energía del motor auxiliar de tipo ",
        headerMainEngineEmissions: "¿Estás seguro de que quieres borrar las emisiones del motor principal llamado ",
        headerMainEngineEnergySavings:
            "¿Está seguro de que desea eliminar el motor principal de ahorro de energía con el tipo ",

        //AddAuxEngineEmissionsComponent

        auxiliaryEngine: "Motor Auxiliar",
        propulsionType: "Tipo de Propulsión",
        fuelType: "Tipo de combustible",
        fuelConsumption: "Consumo de combustible",
        certifiedFuelConsumption: "Consumo específico de combustible certificado",
        electricalPowerConsumption: "Potencia eléctrica consumida",
        averageWeight: "Eficiencia media ponderada del generador",
        shaftMotor: "Motor de eje",
        ratedPower: "Consumo nominal de energía",
        shaftMotorEfficiency: "Eficiencia del motor de eje",
        reliquefaction: "Elemento de licuefacción",
        cargoTank: "LNG Capacidad del tanque de carga",
        cargoTankCapacity: "Capacidad tanque de carga",
        rateGas: "Ratio de evaporación de gas al día",
        rateGasLiq: "Gas de evaporación que debe relicuarse",
        entireGasBoil: "gas de evaporación total",
        highPressureGasCompressor: "Compresor para gas a alta presión",
        lowPressureGasCompressor: "Compresor para gas a baja presión",
        vliquid: "Capacidad total neta de combustible líquido",
        vgas: "Capacidad total neta de combustible de gas",
        kliquid: "Tasa de llenado de los depósitos de combustible líquido",
        kgas: "Tasa de llenado de los depósitos de gas",
        sfcLiquid: "Consumo específico de combustible líquido certificado",
        sfcGas: "Consumo específico de combustible gas certificado",
        sfcmePilot: "Consumo específico de combustible pilot certificado",
        secondFuel: "Segundo tipo de combustible",
        liquid: "liquido",

        //AddAuxEngineEnergeSavingsComponent

        addAuxEngineEnergeSavingsComponentHeader:
            "Tecnologías innovadoras de eficiencia energética de los motores auxiliares",
        energyEfficiency: "Tecnologías de eficiencia energética",
        feffpaeeff: "Suministro de energía",
        feffpaeeff2: "Energía recuperada",

        //AddMainEngineEmissionsComponent

        addMainEngineEmissionsComponentHeader: "Motor principal",
        mcrme: "Potencia nominal instalada",
        shaftGenerator: "Generador acoplado",
        mcrpto: "Potencia nominal del generador de eje",
        powerLimit: "Límite de potencia",
        powerLimitType: "Tipo de límite de potencia",

        //AddMainEngineEnergySavingsComponent

        addMainEngineEnergySavingsComponentHeader:
            "Tecnologías innovadoras de eficiencia energética del motor principal",
        feffpeff: "Reducción de la potencia de propulsión",
        paeeffal: "Potencia auxiliar adicional necesaria para el sistema de lubricación por aire",

        //EconomicForm

        baseConfiguration: "Configuración base",
        miscellaneousCosts: "Costes diversos",
        configuration: "Configuración",
        technicalStopDuration: "Duración de la parada técnica",
        dailyCosts: "Gastos diarios",
        initialInvestment: "Inversión inicial",
        financing: "Financiación",
        amountToFinance: "Importe de la financiación",
        interestRate: "Tipo de interés",
        amortizationPeriod: "Período de amortización",
        discountRate: "Tasa de descuento",
        timeDays: "Días",
        fuelName: "Tipo de combustible",
        price: "Precio",
        annualConsumption: "Consumo anual",
        annualConsumptionType: "Unidad del consumo anual",
        annualPriceIncrease: "Incremento de precio anual",
        //LoggingComponent

        loggingComponentHeader1: "Iniciar sesión",
        loggingComponentHeader2: "Registrarse",
        password: "Contraseña",
        email: "Email",
        firstName: "Nombre",
        lastName: "Apellidos",
        company: "Compañia/Empresa",
        charge: "Posición",
        sector: "Sector de la empresa",
        password2: "Confirmar contraseña",
        loggingText1_1: "¿Eres nuevo en Ecobuq?",
        loggingText1_2: "¿Ya tiene una cuenta?",
        loggingText2_1: "Crear una cuenta.",
        loggingText2_2: " Iniciar sesión con una cuenta.",
        toast1: "Ya existe una cuanta con el mismo email.",

        //CarbonForm

        headerCarbonForm: "Clasificación del Índice de Carbono (ICE)",
        fuelConsumptionPerYear: "Consumo de combustible por año",
        totalDistancia: "Total de distancia recorrida"
    },
    en: {
        // ShipsTable traducciones
        app_title: "ECOBUQ",
        home_p: `Simulator for configuring measures on ships 
    to improve their economic and environmental efficiency, which allows the calculation of the 
    <strong>Eco-efficiency Index</strong> and the <strong>the carbon intensity index</strong> obtained with the measures.`,
        headerConf: "Configurations",
        toastProgressSpinner: "Wait a moment, please...",
        name: "Name",
        shipType: "Ship Type",
        requiredEEXI: "Required EEXI",
        attainedEEXI: "Attained EEXI",
        actions: "Actions",
        newShipBtn: "New Ship",
        tooltipEditShip: "Edit Ship",
        tooltipNewConfig: "New Configuration",
        tooltipDeleteShip: "Delete Ship",
        tooltipChart: "Show Chart",
        tooltipEditConfig: "Edit Configuration",
        tooltipEditEco: "Edit Economic",
        tooltipSetBase: "Set as Base",
        tooltipAlreadyBase: "Already Base",
        tooltipCloneConfig: "Clone Configuration",
        tooltipDeleteConfig: "Delete Configuration",

        dialogChart: "Economic Data",
        dialogChartSelec: "Select data",
        deleteShipDisplay: "Are your sure you want to delete the ship called ",
        deleteConfigDisplay: "Are your sure you want to delete the configuration called ",

        //EditShip traducciones
        shipName: "Ship Name",
        imoNumber: "IMO Number",
        iceClass: "Icd Class",
        grossTonnage: "Gross Tonnage",
        capacityDeadWeight: "Capacity DeadWeight",
        dateKeelLaid: "Keel laid down date",
        dateSigning: "Contract signing date",
        dataDelivery: "Ship delivery date",
        displacementVolume: "Displacement Volume",
        lengthOverall: "Length Overall",
        lengthbtwPerpendicular: "Length between perpendiculars",
        summerLoad: "Summer load line draught",
        breadth: "Breadth",
        shipSpeed: "Ship speed",
        vTanks: "Total cubic capacity of the cargo tanks",
        powerLimitElement: "Speed-power curves obtained from model testing at final stage or sea trial report",
        vsService: "Testing service speed",
        dwtsService: "Testing deadweight",
        psService: "Testing main engine power",
        structuralEnhancement: "Ship specific voluntary structural enhancement",
        lwtReferenceDesign: "Reference design lightweight",
        lwtEnhancedDesign: "Enhanced design lightweight",
        has_csr: "Ships under the Common Structural Rules (CSR)",
        deadweightCSR: "Deadweight CSR",
        lightweightCSR: "Light weight CSR",
        has_sideLoaders: "Side loaders are present?",
        capacityNoSideloaders: "Capacity without sideloaders",
        capacitySideloaders: "Capacity with sideloaders",
        highSpeedCruise: "High Speed Cruise?",
        has_roro_ramps: "RO-RO ramp is present?",
        capacityNoRORORamp: "Capacity without RO-RO ramp",
        capacityRORORamp: "Capacity with RO-RO ramp",
        isChemicalTanker: "Chemical Tanker?",
        capacityCorrection: "Capacity correction factor for ice-classed ships?",
        cb: "Block coefficient",
        addCrane: "Add Crane",
        removeCrane: "Remove Crane",
        requiredFields: "Required fields",
        save: "Save",
        cancel: "Cancel",
        showInfo: "Show Info",
        calcRequiredEEXI: "Calc Required EEXI",
        create: "Create",
        description: "description",
        close: "Close",

        //FormEditConfigurations

        configName: "Configuration name",
        configDescription: "Configuration description",
        modifiedGT: "modified GT",
        modifiedDWT: "modified DWT",
        forceVRefCalc: "Force Vref Calc",
        factors: "Factors",
        shipDesignEle: "Ship specific design elements",
        capacityFactor: "Capacity factor for technical/regulatory limitation on capacity",
        fi: "fi unapply",
        cubicCapacity: "Cubic capacity correction factor",
        fc: "fc unapply",
        factorGeneral: "Factor for general cargo ships equipped with cranes and other cargo-related gear",
        factorSpeed: "Factor for speed reduction at sea",
        fw: "fw unapply",
        factorIce: "Factor for ice-classed ships having IA or IA Super",
        fm: "fm unapply",
        capacity: "Capacity",
        calculate: "Calculate",
        fj: "fj unapply",

        //ShipsPartTable

        logger: "EEXI Calc Logger",
        addAnother: "Add another",
        pendingComponent: "Pending Component",
        confirm: "Confirm",
        headerAuxiliaryEngineEmissions: "Are your sure you want to delete the Auxiliary Engine Emissions called",
        headerAuxiliaryEngineEnergySavings:
            "Are your sure you want to delete the Auxiliary Engine Energy Savings whit type ",
        headerMainEngineEmissions: "Are your sure you want to delete the Main Engine Emissions called ",
        headerMainEngineEnergySavings: "Are your sure you want to delete the Main Engine Energy Savings with type ",

        //AddAuxEngineEmissionsComponent

        auxiliaryEngine: "Auxiliary Engine",
        propulsionType: "Propulsion Type",
        fuelType: "Fuel Type",
        fuelConsumption: "Fuel consumption",
        certifiedFuelConsumption: "Certified specific fuel consumption",
        electricalPowerConsumption: "Electrical power consumption",
        averageWeight: "Weighted average efficiency of the generator",
        shaftMotor: "Shaft motor",
        ratedPower: "Rated power consumption",
        shaftMotorEfficiency: "Shaft motor efficiency",
        reliquefaction: "Reliquefaction element",
        cargoTank: "LNG Cargo Tank Capacity",
        cargoTankCapacity: "CargoTankCapacity",
        rateGas: "Rate of boil-off gas per day",
        rateGasLiq: "Boil-off gas to be re-liquefied",
        entireGasBoil: "entire boil-off gas",
        highPressureGasCompressor: "Compressor for supplying high-pressured gas",
        lowPressureGasCompressor: "Compressor for supplying low-pressured gas",
        vliquid: "Total net liquid fuel capacity",
        vgas: "Total net gas fuel capacity",
        kliquid: "Filling rate for liquid fuel tanks",
        kgas: "Filling rate for gas fuel tanks",
        sfcLiquid: "Certified specific liquid fuel consumption",
        sfcGas: "Certified specific gas fuel consumption",
        sfcmePilot: "Certified specific pilot fuel consumption",
        secondFuel: "Second fuel type",
        liquid: "liquid",

        //AddAuxEngineEnergeSavingsComponent

        addAuxEngineEnergeSavingsComponentHeader:
            "Innovative auxiliary motor electrical energy efficiency technologies",
        energyEfficiency: "Energy efficiency technologies",
        feffpaeeff: "Power supplied",
        feffpaeeff2: "Power recovered",

        //AddMainEngineEmissionsComponent

        addMainEngineEmissionsComponentHeader: "Main engine",
        mcrme: "Rated installed power",
        shaftGenerator: "Shaft generator",
        mcrpto: "Rated power of shaft generator",
        powerLimit: "Power limit",
        powerLimitType: "Power limit type",

        //AddMainEngineEnergySavingsComponent

        addMainEngineEnergySavingsComponentHeader: "Innovative main engine mechanical energy efficiency technologies",
        feffpeff: "Reduction in propulsion power",
        paeeffal: "Additional auxiliary power needed for air lubrication system",

        //EconomicForm

        baseConfiguration: "Base Configuration",
        miscellaneousCosts: "Miscellaneous costs",
        configuration: "Configuration ",
        technicalStopDuration: "Technical stop duration",
        dailyCosts: "Daily costs",
        initialInvestment: "Initial investment",
        financing: "Financing",
        amountToFinance: "Amount to finance",
        interestRate: "Interest rate",
        amortizationPeriod: "Amortization period",
        discountRate: "Discount rate",
        timeDays: "Days",
        fuelName: "Fuel type",
        price: "Price",
        annualConsumption: "Annual consumption",
        annualConsumptionType: "Annual consumption type",
        annualPriceIncrease: "Annual price increase",

        //LoggingComponent

        loggingComponentHeader1: "Sign In",
        loggingComponentHeader2: "Sign Up",
        password: "Password",
        email: "Email",
        firstName: "First Name",
        lastName: "Last Name",
        company: "Company",
        charge: "Position",
        sector: "Sector ",
        password2: "Confirm Password",
        loggingText1_1: "New to Ecobuq?",
        loggingText1_2: "Already have an account?",
        loggingText2_1: "Create an account.",
        loggingText2_2: " Sign in an account.",
        toast1: "Already exist an account with the same email.",

        //CarbonForm

        headerCarbonForm: "Carbon Index Indicator (CII) Rating",
        fuelConsumptionPerYear: "Fuel consumption per year",
        totalDistancia: "Total distance traveled"
    }
}

const i18n = createI18n({
    locale: "es",
    fallbackLocale: "en",
    messages
})

export default i18n
